module.exports = __webpack_public_path__ + "img/8758b93.jpg";